import { type ReactNode } from '@tanstack/react-router'
import { Popover } from 'antd'
import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = Omit<ComponentPropsWithoutRef<typeof Popover>, 'content'> & {
  dot?: boolean
  popoverContent?: ReactNode
  ['data-testid']?: string
}

export const HeaderItem: FC<Props> = ({
  className,
  children,
  dot,
  popoverContent,
  ['data-testid']: dataTestid,
  ...props
}) => {
  return (
    <Popover
      trigger={['hover']}
      placement="bottomRight"
      arrow={false}
      {...props}
      content={popoverContent}
    >
      <div
        data-testid={dataTestid}
        className={clsx([
          'relative flex h-[38px] w-[38px] items-center justify-center text-gray-2',
          popoverContent && 'cursor-pointer',
          className
        ])}
      >
        {children}
        {dot && (
          <div className="absolute left-1/2 top-0 -ml-[3px] h-1.5 w-1.5 rounded-full bg-red" />
        )}
      </div>
    </Popover>
  )
}
